export const changeStyle = function () {
  // console.log(this.$refs.asideTab)
  // this.$refs.buttonBackground && (this.$refs.buttonBackground.style.background = this.style.buttonBackground)
  // this.$refs.send && (this.$refs.send.style.border = `1px solid ${this.style.color}`)
  // this.$refs.send && (this.$refs.send.style.color = this.style.color)
  // this.$refs.check && (this.$refs.check.style.background = this.style.buttonBackground)

}
export const isApp = () => {
  return process.env.APP_NAME ? `${process.env.APP_NAME.substr(0, 1).toUpperCase()}LR` : 'APP'
}
export const chargeOptions = () => {
  return [{
    //充值数据
    value: "50000",
    label: "100000 IDR",
  }, {
    value: "150000",
    label: "300000 IDR",
  }, {
    value: "250000",
    label: "500000 IDR",
  }, {
    value: "500000",
    label: "1000000 IDR",
  }, {
    value: "1000000",
    label: "2000000 IDR",
  }, {
    value: "2000000",
    label: "4000000 IDR",
  }]
}
// function loadStyles(url) {
//   var link = document.createElement("link");
//   link.rel = "stylesheet";
//   link.type = "text/css";
//   link.href = url;
//   var head = document.getElementsByTagName("head")[0];
//   head.appendChild(link);
// }
// export const changeStyle = function () {
//   console.log(document.getElementsByTagName("head")[0])
//   console.log(STYLE_CONFIG[process.env.APP_NAME])
//   export default STYLE_CONFIG[process.env.APP_NAME]
// }



// WEBPACK FOOTER //
// ./src/utils/changeStyle.js